import { render, staticRenderFns } from "./StudyNewPageUnfinished.vue?vue&type=template&id=2f198ed1&scoped=true"
import script from "./StudyNewPageUnfinished.vue?vue&type=script&lang=js"
export * from "./StudyNewPageUnfinished.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageUnfinished.vue?vue&type=style&index=0&id=2f198ed1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f198ed1",
  null
  
)

export default component.exports